import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineComponent, ref, reactive, type UnwrapNestedRefs } from 'vue';
import CwConfirm from './_share/Confirm.vue';
import CwDetailFile from './DetailFile.vue';
import { State } from '../store/state-confirm'; /* eslint-disable-line */


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmFile',
  setup(__props, { expose }) {

defineComponent({ name: 'CwConfirmFile' });

const propsDetailFile: UnwrapNestedRefs<object | undefined> = reactive({});

const confirm = ref();

const show = async (obj: State): Promise<object> => {
  Object.assign(propsDetailFile, obj.props);
  obj.props = {}; /* eslint-disable-line no-param-reassign */
  return confirm.value.show(obj);
};

expose({ show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CwConfirm, {
    ref_key: "confirm",
    ref: confirm,
    el: { component: CwDetailFile, props: propsDetailFile }
  }, null, 8, ["el"]))
}
}

})